import React from 'react';
import { useNavigate } from 'react-router-dom';

const Hero = ({ data, stats }) => {
  const navigate = useNavigate();

  const config = data || {
    headline: {
      beforeHighlight: "The World's Premier and Most Transparent",
      highlighted: "Multi-Channel Network",
      afterHighlight: ""
    },
    description: "Join creators earning guaranteed revenue share. Connect with investors for funding. Access professional channel management and YouTube CMS.",
    buttons: [
      { text: "Apply as Creator", link: "/apply", style: "primary" },
      { text: "Become an Investor", link: "/investment-opportunities", style: "secondary" }
    ],
    badges: [
      { icon: "green", text: "24hr Review" },
      { icon: "blue", text: "Revenue Share" },
      { icon: "purple", text: "CMS Protection" }
    ],
    statsCards: {
      revenueShare: { value: "75%", label: "Revenue Share" },
      channels: { label: "Channels", useStatsValue: true },
      creators: { label: "Creators", useStatsValue: true, suffix: "+" }
    },
    platformStats: {
      approvedCreators: { label: "Approved Creators", multiplier: 0.5, suffix: "+" },
      avgEarnings: { label: "Avg Monthly Payout", useStatsValue: true }
    }
  };

  const safeStats = stats || {
    creators: 0,
    channels: 0,
    averageEarnings: '$0'
  };

  return (
    <section className="relative overflow-hidden py-14 lg:py-24">
      <div aria-hidden="true" className="absolute inset-0 -z-10 opacity-20">
        <div className="absolute -top-20 -right-20 w-[36rem] h-[36rem] rounded-full blur-3xl bg-gradient-to-r from-blue-600 to-purple-600"></div>
      </div>

      <div className="container mx-auto px-4 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight">
            {config.headline.beforeHighlight} <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              {config.headline.highlighted}
            </span>
            {config.headline.afterHighlight && <> {config.headline.afterHighlight}</>}
          </h1>

          <p className="mt-4 text-lg text-slate-600">
            {config.description.replace('{creators}', safeStats.creators || '0')}
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            {config.buttons.map((button, index) => (
              <button
                key={index}
                onClick={() => navigate(button.link)}
                className={
                  button.style === 'primary'
                    ? "px-5 py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-blue-600 to-purple-600 shadow hover:shadow-lg transition-all"
                    : "px-5 py-3 rounded-xl font-semibold border-2 border-slate-300 hover:border-blue-600 transition-all"
                }
              >
                {button.text}
              </button>
            ))}
          </div>

          <div className="mt-6 flex items-center gap-6 text-sm text-slate-600">
            {config.badges.map((badge, index) => (
              <div key={index} className="flex items-center gap-2">
                <span className={`w-2.5 h-2.5 rounded-full bg-${badge.icon}-500`}></span>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:justify-self-end">
          <div className="bg-white/80 border border-slate-200 rounded-2xl shadow-xl p-5 sm:p-6 max-w-xl w-full">
            <div className="grid grid-cols-3 gap-3 text-center">
              {/* Value proposition cards instead of unfounded stats */}
              <div className="p-4 rounded-xl bg-gradient-to-br from-blue-50 to-blue-100">
                <div className="text-2xl font-extrabold text-blue-600">75%</div>
                <div className="text-xs text-slate-600">Creator share</div>
              </div>
              <div className="p-4 rounded-xl bg-gradient-to-br from-purple-50 to-purple-100">
                <div className="text-2xl font-extrabold text-purple-600">85%</div>
                <div className="text-xs text-slate-600">Investor pool</div>
              </div>
              <div className="p-4 rounded-xl bg-gradient-to-br from-green-50 to-green-100">
                <div className="text-2xl font-extrabold text-green-600">10%</div>
                <div className="text-xs text-slate-600">Platform fee</div>
              </div>
            </div>

            <div className="mt-4 p-4 rounded-xl bg-slate-50">
              <div className="text-sm font-semibold text-slate-700 mb-2">Now in soft launch</div>
              <div className="text-xs text-slate-600 leading-relaxed">
                We are onboarding a hand-picked cohort of creators, producers and investors.
                Live network statistics will appear here as the first cohort goes active.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;